// Translated Structured Data (JSON-LD) for Beatenberg Resort & Spa
import { SEOLanguage } from './seoTranslations';
import { hotelReviews, mapReviewsToJsonLd } from './reviews';

// Translations for structured data descriptions
const structuredDataTranslations = {
  en: {
    hotelDescription: "Discover Switzerland's purest wellness sanctuary. 15-acre lakefront luxury resort in Beatenberg with panoramic Alpine views, NutraSwiss spa programs, and authentic Swiss hospitality.",
    websiteDescription: "Official website of Beatenberg Resort & Spa - Swiss Alpine luxury resort with wellness spa and panoramic mountain views",
    organizationDescription: "Luxury Swiss Alpine resort offering wellness spa experiences, fine dining, and panoramic mountain views in Beatenberg, Switzerland.",
    spaDescription: "Comprehensive wellness and spa services including NutraSwiss programs, Alpine-inspired treatments, and luxury spa facilities.",
    spaDetailedDescription: "Luxury spa featuring NutraSwiss wellness programs, Alpine-inspired treatments, and comprehensive spa facilities with panoramic mountain views.",
    restaurantDescription: "Authentic Swiss and international cuisine with panoramic Alpine views. Experience farm-to-table dining featuring local ingredients and traditional Swiss specialties.",
    eventsDescription: "Luxury event venue for weddings, corporate events, and private celebrations with panoramic Alpine views. Comprehensive planning services and elegant event spaces.",
    eventPlanningDescription: "Comprehensive wedding planning, corporate event coordination, and private celebration services in the Swiss Alps.",
    attractionsDescription: "Discover world-famous Swiss Alpine attractions, activities, and experiences from Beatenberg Resort & Spa. Easy access to Jungfraujoch, Interlaken, and premier hiking trails.",
    seasonalActivitiesDescription: "Year-round activities and experiences near Beatenberg Resort & Spa",
    accommodationsDescription: "Discover our luxury rooms and suites at Beatenberg Resort & Spa. From cozy single rooms to spacious family suites, all with stunning Alpine views and Swiss comfort.",
    accommodationsPageName: "Rooms & Suites - Beatenberg Resort & Spa",
    accommodationsListName: "Hotel Rooms and Suites",
    accommodationsListDescription: "Luxury accommodations with Alpine views",
    familySuiteName: "Family Suite",
    familySuiteDescription: "Spacious 65m² family suite with panoramic views, kitchenette, and multiple sleeping areas for up to 6 guests.",
    juniorSuiteName: "Junior Suite",
    juniorSuiteDescription: "Luxurious 50m² junior suite with separate living area, king bedroom, and breathtaking mountain views.",
    tripleRoomName: "Standard Triple Room",
    tripleRoomDescription: "Comfortable triple room perfect for families or small groups with flexible bedding arrangements.",
    doubleRoomName: "Superior Double Room",
    doubleRoomDescription: "Enhanced 35m² double room with superior amenities, king bed, and option for additional sofa bed.",
    singleRoomName: "Classic Single Room - Alpine Comfort",
    singleRoomDescription: "Cozy 20m² single room with Alpine-inspired wooden decor, modern amenities, and comfortable bedding.",
    alpineDoubleTwinName: "Alpine Double/Twin - Balcony & Lake View",
    alpineDoubleTwinDescription: "Flexible 32m² room with double or twin bed configuration, private balcony, and stunning Lake Thun views.",
    alpineClassicDoubleTwinName: "Alpine Classic Double/Twin - Village View",
    alpineClassicDoubleTwinDescription: "Classic 28m² room with flexible bedding, charming village views, and authentic Alpine atmosphere.",
    jungfrauSingleName: "Jungfrau Single - Balcony & Lake View",
    jungfrauSingleDescription: "Premium 20m² single room with private balcony overlooking Lake Thun, perfect for solo travelers.",
    heritageSingleName: "Heritage Single - Village View",
    heritageSingleDescription: "Classic 20m² single room with peaceful village views and authentic Swiss heritage character.",
    faqCheckInOut: "What is your check-in and check-out time?",
    faqCheckInOutAnswer: "Check-in time is 3:00 PM (15:00) and check-out time is 11:00 AM. Early check-in and late check-out may be available upon request, subject to availability and additional charges.",
    faqBreakfast: "Is breakfast included in the room rate?",
    faqBreakfastAnswer: "Yes, bed and breakfast is available at Beatenberg Resort & Spa. Our breakfast offerings feature fresh local ingredients and traditional Swiss specialties to start your day perfectly.",
    faqViews: "Do all rooms have mountain or lake views?",
    faqViewsAnswer: "Most of our rooms and suites feature stunning views of either the Alpine mountains, Lake Thun, or our charming village views. Our beautiful village views are a hidden gem, offering peaceful vistas of authentic Swiss Alpine architecture and local charm. Specific view preferences can be requested at the time of booking, subject to availability.",
    faqAmenities: "What amenities are included in the rooms?",
    faqAmenitiesAnswer: "All rooms include free WiFi, flat-screen TV, minibar, premium bedding, ensuite bathroom with luxury toiletries, and beautiful views. Suites also feature private balconies and espresso machines. Access to our spa facilities is available at an additional cost with special rates for hotel guests.",
    // Spa FAQ
    faqSpaBooking: "How do I book spa treatments?",
    faqSpaBookingAnswer: "You can easily build your personalized wellness plan using our service list feature. Browse our treatments (Therapeutic Massages, Sauna & Thermal Wellness Package, or PelviPower Training), add services to your list, and submit your inquiry with your preferred date and time. Our spa concierge will contact you to confirm availability and finalize your appointment. You can add multiple treatments to your list before submitting.",
    faqSpaMassages: "What Therapeutic Massage treatments do you offer?",
    faqSpaMassagesAnswer: "We offer eight specialized massage treatments, each available in different durations to suit your needs: Full Body Massage, Relaxing Massage, Sport Massage, Foot Reflexology Massage, Foot & Back Massage, Massage for Back and Neck Pain, Peeling & Full Body Massage, and Energetic Massage. Each treatment is designed to address specific wellness needs, from muscle recovery to deep relaxation. You can view detailed pricing and duration options for each treatment in our service list.",
    faqSpaSaunaPackage: "What is included in the Sauna & Thermal Wellness Package?",
    faqSpaSaunaPackageAnswer: "Our Sauna & Thermal Wellness Package (45 CHF per session) includes exclusive access to all four thermal facilities: Finnish Sauna (90°C), Bio Sauna (60°C), Steam Bath (45°C), and Ice Plunge Pool. The package also includes complimentary coffee, tea, and detox drinks. Sauna hours are 11:00-20:00. This is perfect for detoxification, relaxation, and improving circulation.",
    faqSpaHours: "What are the spa and sauna operating hours?",
    faqSpaHoursAnswer: "Our spa treatment sessions are available from 14:00 to 21:00. The Sauna & Thermal Wellness facilities are open from 11:00-20:00. We recommend booking in advance to secure your preferred time slot, especially during peak seasons.",
    faqSpaPricing: "What are the prices for spa treatments?",
    faqSpaPricingAnswer: "Our Therapeutic Massages range from 80-165 CHF depending on the treatment and duration (25-75 minutes). The Sauna & Thermal Wellness Package is 45 CHF per session and includes access to all four thermal facilities. PelviPower Training is 29 CHF for a 30-minute session. All prices are in CHF. You can view detailed pricing for each treatment on our spa page.",
    faqSpaAccess: "Do I need to be a hotel guest to use the spa?",
    faqSpaAccessAnswer: "Our spa services are available to both hotel guests and external visitors. Hotel guests may receive preferential rates for treatments. The Sauna & Thermal Wellness Package is available to all visitors. Please contact our spa concierge for more information about access and pricing.",
    faqSpaCancellation: "What is your cancellation policy?",
    faqSpaCancellationAnswer: "We understand that plans can change. Please contact our spa concierge at least 24 hours before your scheduled appointment to cancel or reschedule. Cancellations made less than 24 hours in advance may be subject to a fee. We'll work with you to find an alternative time that suits your schedule.",
    faqSpaPreparation: "What should I bring or prepare for my spa visit?",
    faqSpaPreparationAnswer: "For massage treatments, we provide all necessary materials including towels, oils, and treatment products. For the Sauna & Thermal Wellness Package, we recommend bringing a towel and water bottle, though towels are available. Comfortable clothing is recommended. For PelviPower Training, no special preparation is needed - you'll remain fully clothed and seated during the session.",
  },
  de: {
    hotelDescription: "Entdecken Sie die reinste Wellness-Oase der Schweiz. 15-Hektar Luxusresort am Seeufer in Beatenberg mit Alpenpanorama, NutraSwiss Spa-Programmen und authentischer Schweizer Gastfreundschaft.",
    websiteDescription: "Offizielle Website des Beatenberg Resort & Spa - Schweizer Alpines Luxusresort mit Wellness-Spa und Bergpanorama",
    organizationDescription: "Luxuriöses Schweizer Alpenresort mit Wellness-Spa-Erlebnissen, gehobener Gastronomie und Bergpanorama in Beatenberg, Schweiz.",
    spaDescription: "Umfassende Wellness- und Spa-Dienstleistungen einschließlich NutraSwiss-Programme, von den Alpen inspirierte Behandlungen und luxuriöse Spa-Einrichtungen.",
    spaDetailedDescription: "Luxus-Spa mit NutraSwiss Wellness-Programmen, von den Alpen inspirierten Behandlungen und umfassenden Spa-Einrichtungen mit Bergpanorama.",
    restaurantDescription: "Authentische Schweizer und internationale Küche mit Alpenpanorama. Erleben Sie Farm-to-Table-Dining mit lokalen Zutaten und traditionellen Schweizer Spezialitäten.",
    eventsDescription: "Luxus-Veranstaltungslocation für Hochzeiten, Firmenevents und private Feiern mit Alpenpanorama. Umfassende Planungsservices und elegante Veranstaltungsräume.",
    eventPlanningDescription: "Umfassende Hochzeitsplanung, Firmenevents-Koordination und private Feierservices in den Schweizer Alpen.",
    attractionsDescription: "Entdecken Sie weltberühmte Schweizer Alpen-Attraktionen, Aktivitäten und Erlebnisse vom Beatenberg Resort & Spa aus. Einfacher Zugang zum Jungfraujoch, Interlaken und erstklassigen Wanderwegen.",
    seasonalActivitiesDescription: "Ganzjährige Aktivitäten und Erlebnisse in der Nähe des Beatenberg Resort & Spa",
    accommodationsDescription: "Entdecken Sie unsere Luxuszimmer und Suiten im Beatenberg Resort & Spa. Von gemütlichen Einzelzimmern bis zu geräumigen Familiensuiten, alle mit atemberaubendem Alpenblick und Schweizer Komfort.",
    accommodationsPageName: "Zimmer & Suiten - Beatenberg Resort & Spa",
    accommodationsListName: "Hotelzimmer und Suiten",
    accommodationsListDescription: "Luxusunterkünfte mit Alpenblick",
    familySuiteName: "Familiensuite",
    familySuiteDescription: "Geräumige 65m² Familiensuite mit Panoramablick, Kochnische und mehreren Schlafbereichen für bis zu 6 Gäste.",
    juniorSuiteName: "Junior Suite",
    juniorSuiteDescription: "Luxuriöse 50m² Junior Suite mit separatem Wohnbereich, Kingsize-Schlafzimmer und atemberaubendem Bergblick.",
    tripleRoomName: "Standard-Dreibettzimmer",
    tripleRoomDescription: "Komfortables Dreibettzimmer perfekt für Familien oder kleine Gruppen mit flexiblen Bettenarrangements.",
    doubleRoomName: "Superior Doppelzimmer",
    doubleRoomDescription: "Gehobenes 35m² Doppelzimmer mit überlegenen Annehmlichkeiten, Kingsize-Bett und optionalem Schlafsofa.",
    singleRoomName: "Klassisches Einzelzimmer - Alpine Komfort",
    singleRoomDescription: "Gemütliches 20m² Einzelzimmer mit von den Alpen inspiriertem Holzdekor, modernen Annehmlichkeiten und komfortabler Bettwäsche.",
    alpineDoubleTwinName: "Alpine Doppel-/Zweibett - Balkon & Seeblick",
    alpineDoubleTwinDescription: "Flexibles 32m² Zimmer mit Doppel- oder Zweibettkonfiguration, privatem Balkon und atemberaubendem Blick auf den Thunersee.",
    alpineClassicDoubleTwinName: "Alpine Classic Doppel-/Zweibett - Dorfblick",
    alpineClassicDoubleTwinDescription: "Klassisches 28m² Zimmer mit flexibler Bettenauswahl, charmantem Dorfblick und authentischer Alpenatmosphäre.",
    jungfrauSingleName: "Jungfrau Einzelzimmer - Balkon & Seeblick",
    jungfrauSingleDescription: "Premium 20m² Einzelzimmer mit privatem Balkon und Blick auf den Thunersee, perfekt für Alleinreisende.",
    heritageSingleName: "Heritage Einzelzimmer - Dorfblick",
    heritageSingleDescription: "Klassisches 20m² Einzelzimmer mit friedlichem Dorfblick und authentischem Schweizer Heritage-Charakter.",
    faqCheckInOut: "Was sind Ihre Check-in- und Check-out-Zeiten?",
    faqCheckInOutAnswer: "Die Check-in-Zeit ist 15:00 Uhr und die Check-out-Zeit ist 11:00 Uhr. Früher Check-in und später Check-out können auf Anfrage verfügbar sein, je nach Verfügbarkeit und gegen Aufpreis.",
    faqBreakfast: "Ist das Frühstück im Zimmerpreis enthalten?",
    faqBreakfastAnswer: "Ja, Übernachtung mit Frühstück ist im Beatenberg Resort & Spa verfügbar. Unser Frühstücksangebot umfasst frische lokale Zutaten und traditionelle Schweizer Spezialitäten für den perfekten Start in den Tag.",
    faqViews: "Haben alle Zimmer Berg- oder Seeblick?",
    faqViewsAnswer: "Die meisten unserer Zimmer und Suiten bieten atemberaubende Aussicht auf die Alpen, den Thunersee oder unsere charmanten Dorfansichten. Unsere schönen Dorfansichten sind ein verstecktes Juwel und bieten friedliche Ausblicke auf authentische Schweizer Alpenarchitektur und lokalen Charme. Spezifische Aussichtswünsche können bei der Buchung angefragt werden, je nach Verfügbarkeit.",
    faqAmenities: "Welche Annehmlichkeiten sind in den Zimmern enthalten?",
    faqAmenitiesAnswer: "Alle Zimmer verfügen über kostenloses WLAN, Flachbildfernseher, Minibar, Premium-Bettwäsche, eigenes Bad mit Luxus-Toilettenartikeln und schöne Aussichten. Suiten verfügen außerdem über private Balkone und Espressomaschinen. Der Zugang zu unseren Spa-Einrichtungen ist gegen Aufpreis mit Sonderpreisen für Hotelgäste verfügbar.",
    // Spa FAQ
    faqSpaBooking: "Wie buche ich Spa-Behandlungen?",
    faqSpaBookingAnswer: "Sie können ganz einfach Ihren persönlichen Wellness-Plan mit unserer Service-Liste erstellen. Durchsuchen Sie unsere Behandlungen (Therapeutische Massagen, Sauna & Thermal Wellness Paket oder PelviPower Training), fügen Sie Dienstleistungen zu Ihrer Liste hinzu und senden Sie Ihre Anfrage mit Ihrem bevorzugten Datum und Ihrer bevorzugten Uhrzeit. Unser Spa-Concierge wird Sie kontaktieren, um die Verfügbarkeit zu bestätigen und Ihren Termin zu finalisieren. Sie können mehrere Behandlungen zu Ihrer Liste hinzufügen, bevor Sie absenden.",
    faqSpaMassages: "Welche therapeutischen Massagebehandlungen bieten Sie an?",
    faqSpaMassagesAnswer: "Wir bieten acht spezialisierte Massagebehandlungen an, die jeweils in verschiedenen Dauerzeiten verfügbar sind, um Ihren Bedürfnissen gerecht zu werden: Ganzkörpermassage, Entspannungsmassage, Sportmassage, Fußreflexzonenmassage, Fuß- und Rückenmassage, Massage bei Rücken- und Nackenschmerzen, Peeling & Ganzkörpermassage und Energetische Massage. Jede Behandlung ist darauf ausgelegt, spezifische Wellness-Bedürfnisse zu erfüllen, von Muskelregeneration bis hin zu tiefer Entspannung. Sie können die detaillierten Preise und Daueroptionen für jede Behandlung in unserer Service-Liste einsehen.",
    faqSpaSaunaPackage: "Was ist im Sauna & Thermal Wellness Paket enthalten?",
    faqSpaSaunaPackageAnswer: "Unser Sauna & Thermal Wellness Paket (45 CHF pro Sitzung) beinhaltet exklusiven Zugang zu allen vier Thermal-Einrichtungen: Finnische Sauna (90°C), Bio-Sauna (60°C), Dampfbad (45°C) und Eisbad. Das Paket beinhaltet auch kostenlosen Kaffee, Tee und Entgiftungsgetränke. Die Sauna-Öffnungszeiten sind 11:00-20:00. Dies ist perfekt für Entgiftung, Entspannung und zur Verbesserung der Durchblutung.",
    faqSpaHours: "Was sind die Öffnungszeiten für Spa und Sauna?",
    faqSpaHoursAnswer: "Unsere Spa-Behandlungssitzungen sind von 14:00 bis 21:00 verfügbar. Die Sauna & Thermal Wellness Einrichtungen sind von 11:00-20:00 geöffnet. Wir empfehlen eine Voranmeldung, um Ihren bevorzugten Zeitplatz zu sichern, insbesondere während der Hauptsaison.",
    faqSpaPricing: "Was kosten die Spa-Behandlungen?",
    faqSpaPricingAnswer: "Unsere therapeutischen Massagen liegen je nach Behandlung und Dauer (25-75 Minuten) zwischen 80-165 CHF. Das Sauna & Thermal Wellness Paket kostet 45 CHF pro Sitzung und beinhaltet Zugang zu allen vier Thermal-Einrichtungen. PelviPower Training kostet 29 CHF für eine 30-minütige Sitzung. Alle Preise sind in CHF. Sie können die detaillierten Preise für jede Behandlung auf unserer Spa-Seite einsehen.",
    faqSpaAccess: "Muss ich Hotelgast sein, um das Spa zu nutzen?",
    faqSpaAccessAnswer: "Unsere Spa-Dienstleistungen stehen sowohl Hotelgästen als auch externen Besuchern zur Verfügung. Hotelgäste erhalten möglicherweise Vorzugspreise für Behandlungen. Das Sauna & Thermal Wellness Paket steht allen Besuchern zur Verfügung. Bitte kontaktieren Sie unseren Spa-Concierge für weitere Informationen zu Zugang und Preisen.",
    faqSpaCancellation: "Wie lautet Ihre Stornierungsrichtlinie?",
    faqSpaCancellationAnswer: "Wir verstehen, dass sich Pläne ändern können. Bitte kontaktieren Sie unseren Spa-Concierge mindestens 24 Stunden vor Ihrem geplanten Termin, um zu stornieren oder umzubuchen. Stornierungen, die weniger als 24 Stunden im Voraus erfolgen, können mit einer Gebühr verbunden sein. Wir arbeiten mit Ihnen zusammen, um einen alternativen Zeitpunkt zu finden, der zu Ihrem Zeitplan passt.",
    faqSpaPreparation: "Was sollte ich für meinen Spa-Besuch mitbringen oder vorbereiten?",
    faqSpaPreparationAnswer: "Für Massagebehandlungen stellen wir alle notwendigen Materialien bereit, einschließlich Handtücher, Öle und Behandlungsprodukte. Für das Sauna & Thermal Wellness Paket empfehlen wir, ein Handtuch und eine Wasserflasche mitzubringen, obwohl Handtücher verfügbar sind. Bequeme Kleidung wird empfohlen. Für PelviPower Training ist keine besondere Vorbereitung erforderlich - Sie bleiben während der Sitzung vollständig bekleidet und sitzen.",
  },
  fr: {
    hotelDescription: "Découvrez le sanctuaire de bien-être le plus pur de Suisse. Resort de luxe au bord du lac de 15 acres à Beatenberg avec vues panoramiques alpines, programmes spa NutraSwiss et hospitalité suisse authentique.",
    websiteDescription: "Site officiel du Beatenberg Resort & Spa - Resort de luxe alpin suisse avec spa bien-être et vues panoramiques sur les montagnes",
    organizationDescription: "Resort alpin suisse de luxe offrant des expériences de spa bien-être, une gastronomie raffinée et des vues panoramiques sur les montagnes à Beatenberg, Suisse.",
    spaDescription: "Services complets de bien-être et spa incluant les programmes NutraSwiss, des soins d'inspiration alpine et des installations spa de luxe.",
    spaDetailedDescription: "Spa de luxe proposant des programmes bien-être NutraSwiss, des soins d'inspiration alpine et des installations spa complètes avec vues panoramiques sur les montagnes.",
    restaurantDescription: "Cuisine suisse et internationale authentique avec vues panoramiques alpines. Découvrez une gastronomie de la ferme à la table mettant en vedette des ingrédients locaux et des spécialités suisses traditionnelles.",
    eventsDescription: "Lieu d'événements de luxe pour mariages, événements d'entreprise et célébrations privées avec vues panoramiques alpines. Services de planification complets et espaces événementiels élégants.",
    eventPlanningDescription: "Planification complète de mariages, coordination d'événements d'entreprise et services de célébrations privées dans les Alpes suisses.",
    attractionsDescription: "Découvrez les attractions, activités et expériences alpines suisses mondialement connues depuis le Beatenberg Resort & Spa. Accès facile au Jungfraujoch, Interlaken et aux sentiers de randonnée de premier plan.",
    seasonalActivitiesDescription: "Activités et expériences toute l'année près du Beatenberg Resort & Spa",
    accommodationsDescription: "Découvrez nos chambres et suites de luxe au Beatenberg Resort & Spa. Des chambres simples confortables aux suites familiales spacieuses, toutes avec vues alpines époustouflantes et confort suisse.",
    accommodationsPageName: "Chambres & Suites - Beatenberg Resort & Spa",
    accommodationsListName: "Chambres et Suites d'Hôtel",
    accommodationsListDescription: "Hébergements de luxe avec vues alpines",
    familySuiteName: "Suite Familiale",
    familySuiteDescription: "Suite familiale spacieuse de 65m² avec vues panoramiques, kitchenette et plusieurs espaces de couchage pour jusqu'à 6 personnes.",
    juniorSuiteName: "Suite Junior",
    juniorSuiteDescription: "Suite junior luxueuse de 50m² avec salon séparé, chambre king et vues imprenables sur les montagnes.",
    tripleRoomName: "Chambre Triple Standard",
    tripleRoomDescription: "Chambre triple confortable parfaite pour les familles ou petits groupes avec arrangements de literie flexibles.",
    doubleRoomName: "Chambre Double Supérieure",
    doubleRoomDescription: "Chambre double améliorée de 35m² avec équipements supérieurs, lit king et option canapé-lit supplémentaire.",
    singleRoomName: "Chambre Simple Classique - Confort Alpin",
    singleRoomDescription: "Chambre simple confortable de 20m² avec décor en bois d'inspiration alpine, équipements modernes et literie confortable.",
    alpineDoubleTwinName: "Alpine Double/Twin - Balcon & Vue Lac",
    alpineDoubleTwinDescription: "Chambre flexible de 32m² avec configuration double ou twin, balcon privé et vue imprenable sur le lac de Thoune.",
    alpineClassicDoubleTwinName: "Alpine Classic Double/Twin - Vue Village",
    alpineClassicDoubleTwinDescription: "Chambre classique de 28m² avec literie flexible, vues charmantes sur le village et atmosphère alpine authentique.",
    jungfrauSingleName: "Jungfrau Simple - Balcon & Vue Lac",
    jungfrauSingleDescription: "Chambre simple premium de 20m² avec balcon privé donnant sur le lac de Thoune, parfaite pour les voyageurs solo.",
    heritageSingleName: "Heritage Simple - Vue Village",
    heritageSingleDescription: "Chambre simple classique de 20m² avec vues paisibles sur le village et caractère patrimonial suisse authentique.",
    faqCheckInOut: "Quelles sont vos heures d'arrivée et de départ?",
    faqCheckInOutAnswer: "L'heure d'arrivée est 15h00 et l'heure de départ est 11h00. L'arrivée anticipée et le départ tardif peuvent être disponibles sur demande, selon les disponibilités et moyennant des frais supplémentaires.",
    faqBreakfast: "Le petit-déjeuner est-il inclus dans le tarif de la chambre?",
    faqBreakfastAnswer: "Oui, la formule chambre avec petit-déjeuner est disponible au Beatenberg Resort & Spa. Notre petit-déjeuner comprend des ingrédients locaux frais et des spécialités suisses traditionnelles pour commencer parfaitement votre journée.",
    faqViews: "Toutes les chambres ont-elles une vue sur les montagnes ou le lac?",
    faqViewsAnswer: "La plupart de nos chambres et suites offrent des vues époustouflantes sur les Alpes, le lac de Thoune ou nos charmantes vues sur le village. Nos belles vues sur le village sont un joyau caché, offrant des panoramas paisibles sur l'architecture alpine suisse authentique et le charme local. Les préférences de vue spécifiques peuvent être demandées au moment de la réservation, selon les disponibilités.",
    faqAmenities: "Quels équipements sont inclus dans les chambres?",
    faqAmenitiesAnswer: "Toutes les chambres comprennent WiFi gratuit, télévision à écran plat, minibar, literie premium, salle de bain attenante avec articles de toilette de luxe et de belles vues. Les suites disposent également de balcons privés et de machines à expresso. L'accès à nos installations spa est disponible moyennant un supplément avec des tarifs spéciaux pour les clients de l'hôtel.",
    // Spa FAQ
    faqSpaBooking: "Comment réserver des soins spa?",
    faqSpaBookingAnswer: "Vous pouvez facilement créer votre plan de bien-être personnalisé en utilisant notre fonctionnalité de liste de services. Parcourez nos traitements (Massages Thérapeutiques, Forfait Sauna & Thermal Wellness, ou Formation PelviPower), ajoutez des services à votre liste et soumettez votre demande avec votre date et heure préférées. Notre concierge spa vous contactera pour confirmer la disponibilité et finaliser votre rendez-vous. Vous pouvez ajouter plusieurs traitements à votre liste avant de soumettre.",
    faqSpaMassages: "Quels massages thérapeutiques proposez-vous?",
    faqSpaMassagesAnswer: "Nous proposons huit massages spécialisés, chacun disponible en différentes durées pour répondre à vos besoins: Massage du Corps Entier, Massage Relaxant, Massage Sportif, Massage Réflexologie des Pieds, Massage des Pieds et du Dos, Massage pour Douleurs du Dos et du Cou, Gommage & Massage du Corps Entier, et Massage Énergétique. Chaque traitement est conçu pour répondre à des besoins de bien-être spécifiques, de la récupération musculaire à la relaxation profonde. Vous pouvez consulter les prix détaillés et les options de durée pour chaque traitement dans notre liste de services.",
    faqSpaSaunaPackage: "Qu'est-ce qui est inclus dans le Forfait Sauna & Thermal Wellness?",
    faqSpaSaunaPackageAnswer: "Notre Forfait Sauna & Thermal Wellness (45 CHF par session) comprend un accès exclusif aux quatre installations thermales: Sauna Finlandais (90°C), Sauna Bio (60°C), Bain de Vapeur (45°C) et Piscine de Plongée Glacée. Le forfait comprend également du café, du thé et des boissons détox gratuits. Les heures du sauna sont 11:00-20:00. C'est parfait pour la détoxification, la relaxation et l'amélioration de la circulation.",
    faqSpaHours: "Quelles sont les heures d'ouverture du spa et du sauna?",
    faqSpaHoursAnswer: "Nos séances de soins spa sont disponibles de 14:00 à 21:00. Les installations Sauna & Thermal Wellness sont ouvertes de 11:00-20:00. Nous recommandons de réserver à l'avance pour sécuriser votre créneau horaire préféré, surtout pendant les saisons de pointe.",
    faqSpaPricing: "Quels sont les prix des soins spa?",
    faqSpaPricingAnswer: "Nos Massages Thérapeutiques varient de 80-165 CHF selon le traitement et la durée (25-75 minutes). Le Forfait Sauna & Thermal Wellness coûte 45 CHF par session et comprend l'accès aux quatre installations thermales. La Formation PelviPower coûte 29 CHF pour une session de 30 minutes. Tous les prix sont en CHF. Vous pouvez consulter les prix détaillés pour chaque traitement sur notre page spa.",
    faqSpaAccess: "Dois-je être client de l'hôtel pour utiliser le spa?",
    faqSpaAccessAnswer: "Nos services spa sont disponibles aux clients de l'hôtel et aux visiteurs externes. Les clients de l'hôtel peuvent bénéficier de tarifs préférentiels pour les traitements. Le Forfait Sauna & Thermal Wellness est disponible à tous les visiteurs. Veuillez contacter notre concierge spa pour plus d'informations sur l'accès et les tarifs.",
    faqSpaCancellation: "Quelle est votre politique d'annulation?",
    faqSpaCancellationAnswer: "Nous comprenons que les plans peuvent changer. Veuillez contacter notre concierge spa au moins 24 heures avant votre rendez-vous prévu pour annuler ou reporter. Les annulations effectuées moins de 24 heures à l'avance peuvent être soumises à des frais. Nous travaillerons avec vous pour trouver un moment alternatif qui convient à votre emploi du temps.",
    faqSpaPreparation: "Que dois-je apporter ou préparer pour ma visite au spa?",
    faqSpaPreparationAnswer: "Pour les massages, nous fournissons tous les matériaux nécessaires, y compris les serviettes, les huiles et les produits de traitement. Pour le Forfait Sauna & Thermal Wellness, nous recommandons d'apporter une serviette et une bouteille d'eau, bien que des serviettes soient disponibles. Des vêtements confortables sont recommandés. Pour la Formation PelviPower, aucune préparation spéciale n'est nécessaire - vous resterez entièrement habillé et assis pendant la session.",
  },
  'zh-CN': {
    hotelDescription: "探索瑞士最纯净的养生圣地。15英亩湖畔豪华度假村，坐落于碧滕贝格，享有阿尔卑斯山全景、NutraSwiss水疗项目和正宗瑞士式盛情款待。",
    websiteDescription: "碧滕贝格度假村及水疗中心官方网站 - 瑞士阿尔卑斯豪华度假村，设有养生水疗和山景全景",
    organizationDescription: "瑞士阿尔卑斯豪华度假村，提供养生水疗体验、精致餐饮和瑞士碧滕贝格的山景全景。",
    spaDescription: "全面的养生和水疗服务，包括NutraSwiss项目、阿尔卑斯风格护理和豪华水疗设施。",
    spaDetailedDescription: "豪华水疗中心，提供NutraSwiss养生项目、阿尔卑斯风格护理和全面的水疗设施，享有山景全景。",
    restaurantDescription: "正宗瑞士和国际美食配阿尔卑斯山全景。体验农场直送餐桌，采用本地食材和传统瑞士特色菜肴。",
    eventsDescription: "豪华活动场地，适合婚礼、企业活动和私人庆典，享有阿尔卑斯山全景。提供全面策划服务和优雅的活动空间。",
    eventPlanningDescription: "瑞士阿尔卑斯山的全面婚礼策划、企业活动协调和私人庆典服务。",
    attractionsDescription: "从碧滕贝格度假村及水疗中心探索世界著名的瑞士阿尔卑斯景点、活动和体验。便捷前往少女峰、因特拉肯和一流的徒步小径。",
    seasonalActivitiesDescription: "碧滕贝格度假村及水疗中心附近的全年活动和体验",
    accommodationsDescription: "探索碧滕贝格度假村及水疗中心的豪华客房和套房。从舒适的单人间到宽敞的家庭套房，均享有壮丽的阿尔卑斯山景和瑞士舒适。",
    accommodationsPageName: "客房套房 - 碧滕贝格度假村及水疗中心",
    accommodationsListName: "酒店客房和套房",
    accommodationsListDescription: "享有阿尔卑斯山景的豪华住宿",
    familySuiteName: "家庭套房",
    familySuiteDescription: "宽敞的住宿空间，完美适合家庭，设有独立卧室和壮丽的阿尔卑斯山景。",
    juniorSuiteName: "初级套房",
    juniorSuiteDescription: "豪华的初级套房，提供宽敞的起居区和优质的阿尔卑斯舒适度。",
    tripleRoomName: "三人间",
    tripleRoomDescription: "宽敞的三人间，完美适合小团体，配有舒适的床上用品和阿尔卑斯魅力。",
    doubleRoomName: "双人间",
    doubleRoomDescription: "精致的双人间，配有现代设施和阿尔卑斯山全景。",
    singleRoomName: "单人间",
    singleRoomDescription: "舒适温馨的单人住宿，配有阿尔卑斯风格的木质装饰和现代设施。",
    faqCheckInOut: "您的入住和退房时间是什么时候？",
    faqCheckInOutAnswer: "入住时间为下午3:00（15:00），退房时间为上午11:00。提前入住和延迟退房可根据要求提供，视供应情况和额外费用而定。",
    faqBreakfast: "房费包含早餐吗？",
    faqBreakfastAnswer: "是的，碧滕贝格度假村及水疗中心提供含早餐的住宿。我们的早餐包括新鲜的本地食材和传统瑞士特色菜肴，让您完美开启新的一天。",
    faqViews: "所有客房都有山景或湖景吗？",
    faqViewsAnswer: "我们的大部分客房和套房都享有阿尔卑斯山、图恩湖或迷人村庄景观的壮丽景色。我们美丽的村庄景观是一个隐藏的瑰宝，提供宁静的正宗瑞士阿尔卑斯建筑和当地魅力的景致。可在预订时要求特定景观偏好，视供应情况而定。",
    faqAmenities: "客房包含哪些设施？",
    faqAmenitiesAnswer: "所有客房均配有免费WiFi、平板电视、迷你吧、优质床上用品、带豪华洗浴用品的套间浴室以及美丽的景观。套房还配有私人阳台和浓缩咖啡机。我们的水疗设施需额外付费，酒店客人可享受特别优惠价格。",
    // Spa FAQ
    faqSpaPrograms: "NutraSwiss养生项目包括什么？",
    faqSpaProgramsAnswer: "我们的NutraSwiss养生项目包括个性化健康评估、定制治疗计划、营养指导、水疗护理、健身课程和全面的养生咨询。项目为期3-7天，根据您的具体健康和养生目标量身定制。我们还为时间有限的客人提供快速放松选项。",
    faqSpaAccess: "预订客房是否包含水疗设施？",
    faqSpaAccessAnswer: "酒店客人可以特惠价格使用我们的水疗设施，包括室内游泳池、桑拿房、蒸汽房和休闲区。个人护理和养生项目需额外付费，我们的客人可享受优惠价格。",
    faqSpaBooking: "需要提前预订水疗护理吗？",
    faqSpaBookingAnswer: "是的，我们强烈建议提前预订水疗护理以确保可用性，特别是在旺季期间。您可以在预订客房时预订护理，也可以直接联系我们的水疗礼宾部。",
    faqSpaHours: "水疗设施的开放时间是什么？",
    faqSpaHoursAnswer: "我们的水疗设施包括桑拿房、蒸汽房和休闲区每天7:00至22:00开放。护理时段为9:00至20:00。请咨询水疗前台了解具体护理的可用性。",
  },
  ko: {
    hotelDescription: "스위스의 가장 순수한 웰니스 성지를 발견하세요. 베아텐베르크의 15에이커 호숫가 럭셔리 리조트, 알프스 파노라마 뷰, NutraSwiss 스파 프로그램과 정통 스위스 환대를 갖추고 있습니다.",
    websiteDescription: "베아텐베르크 리조트 & 스파 공식 웹사이트 - 웰니스 스파와 파노라마 산악 전망을 갖춘 스위스 알파인 럭셔리 리조트",
    organizationDescription: "스위스 베아텐베르크에서 웰니스 스파 경험, 파인 다이닝, 파노라마 산악 전망을 제공하는 럭셔리 스위스 알파인 리조트.",
    spaDescription: "NutraSwiss 프로그램, 알프스 테라피, 럭셔리 스파 시설을 포함한 포괄적인 웰니스 및 스파 서비스.",
    spaDetailedDescription: "파노라마 산악 전망을 갖춘 NutraSwiss 웰니스 프로그램, 알프스 테라피, 포괄적인 스파 시설을 제공하는 럭셔리 스파.",
    restaurantDescription: "파노라마 알프스 전망과 함께하는 정통 스위스 및 세계 요리. 현지 식재료와 전통 스위스 특선 요리를 선보이는 팜투테이블 다이닝을 경험하세요.",
    eventsDescription: "파노라마 알프스 전망을 갖춘 웨딩, 기업 행사, 프라이빗 축하 행사를 위한 럭셔리 이벤트 베뉴. 포괄적인 기획 서비스와 우아한 이벤트 공간.",
    eventPlanningDescription: "스위스 알프스에서의 포괄적인 웨딩 기획, 기업 행사 조정, 프라이빗 축하 행사 서비스.",
    attractionsDescription: "베아텐베르크 리조트 & 스파에서 세계적으로 유명한 스위스 알프스 명소, 액티비티, 체험을 탐험하세요. 융프라우요흐, 인터라켄, 프리미엄 하이킹 트레일로 쉽게 접근 가능.",
    seasonalActivitiesDescription: "베아텐베르크 리조트 & 스파 근처의 연중 액티비티 및 체험",
    accommodationsDescription: "베아텐베르크 리조트 & 스파의 럭셔리 객실과 스위트를 만나보세요. 아늑한 싱글룸부터 넓은 패밀리 스위트까지, 모두 멋진 알프스 전망과 스위스 안락함을 갖추고 있습니다.",
    accommodationsPageName: "객실 & 스위트 - 베아텐베르크 리조트 & 스파",
    accommodationsListName: "호텔 객실 및 스위트",
    accommodationsListDescription: "알프스 전망을 갖춘 럭셔리 숙박",
    familySuiteName: "패밀리 스위트",
    familySuiteDescription: "가족에게 완벽한 넓은 숙소로, 독립 침실과 멋진 알프스 전망을 갖추고 있습니다.",
    juniorSuiteName: "주니어 스위트",
    juniorSuiteDescription: "넓은 거실 공간과 프리미엄 알파인 안락함을 제공하는 럭셔리 주니어 스위트.",
    tripleRoomName: "트리플 룸",
    tripleRoomDescription: "소규모 그룹에 완벽한 넓은 트리플 숙소로, 편안한 침구와 알파인 매력을 갖추고 있습니다.",
    doubleRoomName: "더블 룸",
    doubleRoomDescription: "현대적인 편의 시설과 파노라마 알프스 전망을 갖춘 세련된 더블 룸.",
    singleRoomName: "싱글 룸",
    singleRoomDescription: "알파인 스타일의 우드 장식과 현대적인 편의 시설을 갖춘 아늑하고 편안한 싱글 숙소.",
    faqCheckInOut: "체크인 및 체크아웃 시간은 언제인가요?",
    faqCheckInOutAnswer: "체크인 시간은 오후 3시(15:00)이며 체크아웃 시간은 오전 11시입니다. 얼리 체크인 및 레이트 체크아웃은 요청 시 가능하며, 이용 가능 여부 및 추가 요금이 적용됩니다.",
    faqBreakfast: "객실 요금에 조식이 포함되어 있나요?",
    faqBreakfastAnswer: "네, 베아텐베르크 리조트 & 스파에서 조식 포함 숙박이 가능합니다. 저희 조식은 신선한 현지 식재료와 전통 스위스 특선 요리로 구성되어 하루를 완벽하게 시작하실 수 있습니다.",
    faqViews: "모든 객실에 산 또는 호수 전망이 있나요?",
    faqViewsAnswer: "대부분의 객실과 스위트는 알파인 산맥, 툰 호수 또는 매력적인 마을 전망의 멋진 전망을 자랑합니다. 저희의 아름다운 마을 전망은 숨겨진 보석으로, 정통 스위스 알파인 건축과 현지 매력의 평화로운 풍경을 제공합니다. 특정 전망 선호도는 예약 시 요청할 수 있으며 이용 가능 여부에 따라 제공됩니다.",
    faqAmenities: "객실에 포함된 편의 시설은 무엇인가요?",
    faqAmenitiesAnswer: "모든 객실에는 무료 WiFi, 평면 TV, 미니바, 프리미엄 침구, 럭셔리 세면도구가 비치된 욕실, 아름다운 전망이 포함됩니다. 스위트에는 전용 발코니와 에스프레소 머신도 갖춰져 있습니다. 스파 시설 이용은 추가 비용으로 제공되며 호텔 투숙객에게는 특별 요금이 적용됩니다.",
    // Spa FAQ
    faqSpaPrograms: "NutraSwiss 웰니스 프로그램에는 무엇이 포함되나요?",
    faqSpaProgramsAnswer: "저희 NutraSwiss 웰니스 프로그램에는 개인 맞춤형 건강 평가, 맞춤 치료 계획, 영양 상담, 스파 트리트먼트, 피트니스 세션, 종합 웰니스 상담이 포함됩니다. 프로그램은 3-7일 동안 진행되며 귀하의 특정 건강 및 웰니스 목표에 맞춰 조정됩니다. 시간이 제한된 투숙객을 위한 빠른 휴식 옵션도 제공합니다.",
    faqSpaAccess: "객실 예약 시 스파 시설이 포함되나요?",
    faqSpaAccessAnswer: "호텔 투숙객은 실내 수영장, 사우나, 스팀룸, 휴식 라운지를 포함한 스파 시설을 특별 요금으로 이용하실 수 있습니다. 개별 트리트먼트 및 웰니스 프로그램은 추가 비용이 발생하며 투숙객에게는 우대 요금이 적용됩니다.",
    faqSpaBooking: "스파 트리트먼트를 미리 예약해야 하나요?",
    faqSpaBookingAnswer: "네, 특히 성수기에는 가용성을 보장하기 위해 스파 트리트먼트를 미리 예약하실 것을 강력히 권장합니다. 객실 예약 시 트리트먼트를 예약하시거나 스파 컨시어지에게 직접 문의하실 수 있습니다.",
    faqSpaHours: "스파 시설 운영 시간은 어떻게 되나요?",
    faqSpaHoursAnswer: "사우나, 스팀룸, 휴식 공간을 포함한 스파 시설은 매일 오전 7시부터 오후 10시까지 운영됩니다. 트리트먼트 세션은 오전 9시부터 오후 8시까지 이용 가능합니다. 특정 트리트먼트 이용 가능 여부는 스파 리셉션에 문의해 주세요.",
  }
};

// Helper function to get translated description
export const getTranslatedDescription = (key: keyof typeof structuredDataTranslations.en, language: SEOLanguage = 'en'): string => {
  return structuredDataTranslations[language][key];
};

// Generate translated business structured data
export const getBusinessStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "Hotel",
  "@id": "https://beatenberg-resortspa.ch/#hotel",
  "name": "Beatenberg Resort & Spa",
  "description": getTranslatedDescription('hotelDescription', language),
  "url": "https://beatenberg-resortspa.ch",
  "logo": "https://beatenberg-resortspa.ch/images/phb-icon-180.png",
  "image": [
    "https://beatenberg-resortspa.ch/og-image.jpg",
    "https://beatenberg-resortspa.ch/images/hero-image.webp",
    "https://beatenberg-resortspa.ch/images/hotel-exterior.webp"
  ],
  "telephone": "+41 33 841 00 21",
  "email": "info@beatenberg-resortspa.ch",
  "containsPlace": [
    { "@id": "https://beatenberg-resortspa.ch/dining#restaurant" },
    { "@id": "https://beatenberg-resortspa.ch/spa#spa" }
  ],
  "potentialAction": {
    "@type": "ReserveAction",
    "target": import.meta.env.VITE_BOOKING_URL,
    "result": {
      "@type": "LodgingReservation"
    }
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Spirenwaldstrasse 351",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "hasMap": "https://www.google.com/maps/place/Beatenberg+Resort+%26+Spa/@46.6976705,7.7945598,17z/data=!4m6!3m5!1s0x478fa541a569a32d:0x786359f5bdf1a5e4!8m2!3d46.6976705!4d7.7945598!16s%2Fg%2F1tkc5ln2",
  "starRating": {
    "@type": "Rating",
    "ratingValue": "4",
    "bestRating": "5"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "3.9",
    "reviewCount": "199",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": mapReviewsToJsonLd(hotelReviews),
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Spa & Wellness Center",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification", 
      "name": "Restaurant",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Fitness Center",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Swimming Pool",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Free WiFi",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Parking",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Billiards Room",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Private Balconies",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Conference Facilities",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Mountain View Terrace",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Concierge Service",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Laundry Service",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Children's Activities",
      "value": true
    }
  ],
  "checkinTime": "15:00",
  "checkoutTime": "11:00",
  "petsAllowed": false,
  "smokingAllowed": false,
  "priceRange": "CHF 180 - CHF 600",
  "paymentAccepted": ["Cash", "Credit Card", "Debit Card"],
  "currenciesAccepted": "CHF",
  "openingHours": "Mo-Su 00:00-23:59",
  // OTA listing URLs - Verified canonical URLs from each platform
  "sameAs": [
    "https://www.facebook.com/beatenbergresortspa",
    "https://www.instagram.com/beatenbergresortspa",
    "https://www.linkedin.com/company/beatenberg-resort-spa",
    "https://www.google.com/maps/place/Beatenberg+Resort+%26+Spa/@46.6976705,7.7945598,17z/data=!4m6!3m5!1s0x478fa541a569a32d:0x786359f5bdf1a5e4!8m2!3d46.6976705!4d7.7945598!16s%2Fg%2F1tkc5ln2",
    "https://www.booking.com/hotel/ch/parkhotel-beatenberg-beatenberg.html",
    "https://www.tripadvisor.com/Hotel_Review-g199033-d1020295-Reviews-Beatenberg_Resort_and_Spa_in_Beatenberg_Interlaken-Beatenberg_Canton_of_Bern.html",
    "https://www.expedia.com/Beatenberg-Hotels-Beatenberg-Resort-Spa.h99344037.Hotel-Information",
    "https://www.agoda.com/parkhotel-beatenberg_11/hotel/all/beatenberg-ch.html",
    "https://www.makemytrip.com/hotels-international/switzerland/grindelwald-hotels/beatenberg_resort_spa-details.html",
    "https://www.trivago.com/en-US/oar/beatenberg-resort-and-spa?search=100-41396670",
    "https://www.interlaken.ch/en/hotel/parkhotel-beatenberg"
  ]
});

// Generate translated website structured data
export const getWebsiteStructuredData = (language: SEOLanguage = 'en') => {
  const langCode = language === 'zh-CN' ? 'zh-CN' : (language === 'ko' ? 'ko' : language);
  const baseUrl = language === 'en' ? 'https://beatenberg-resortspa.ch/' : `https://beatenberg-resortspa.ch/${langCode}/`;
  const websiteId = language === 'en' ? 'https://beatenberg-resortspa.ch/#website' : `https://beatenberg-resortspa.ch/${langCode}/#website`;
  
  const schema: any = {
  "@context": "https://schema.org",
  "@type": "WebSite",
    "@id": websiteId,
    "url": baseUrl,
    "inLanguage": langCode,
  "name": "Beatenberg Resort & Spa",
  "description": getTranslatedDescription('websiteDescription', language),
  "publisher": {
      "@id": "https://beatenberg-resortspa.ch/#organization"
    }
  };

  // Add translationOfWork link for non-English versions
  if (language !== 'en') {
    schema.translationOfWork = {
      "@id": "https://beatenberg-resortspa.ch/#website"
    };
  }

  return schema;
};

// Generate translated organization structured data
export const getOrganizationStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://beatenberg-resortspa.ch/#organization",
  "name": "Beatenberg Resort & Spa",
  "url": "https://beatenberg-resortspa.ch",
  "logo": "https://beatenberg-resortspa.ch/images/phb-icon-180.png",
  "description": getTranslatedDescription('organizationDescription', language),
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Spirenwaldstrasse 351",
    "addressLocality": "Beatenberg", 
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+41 33 841 00 21",
    "email": "info@beatenberg-resortspa.ch",
    "contactType": "customer service",
    "availableLanguage": ["English", "German", "French"]
  },
  "sameAs": [
    "https://www.facebook.com/beatenbergresortspa",
    "https://www.instagram.com/beatenbergresortspa",
    "https://www.linkedin.com/company/beatenberg-resort-spa"
  ]
});

// Generate translated spa structured data
export const getSpaStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Wellness & Spa Services",
  "description": getTranslatedDescription('spaDescription', language),
  "provider": {
    "@type": "Organization",
    "name": "Beatenberg Resort & Spa",
    "url": "https://beatenberg-resortspa.ch"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Switzerland"
  },
  "serviceType": "Wellness and Spa Services",
  "offers": {
    "@type": "Offer",
    "description": "Luxury spa treatments and wellness programs",
    "priceRange": "CHF 50 - CHF 500"
  }
});

// Generate translated enhanced spa structured data
export const getEnhancedSpaStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "DaySpa",
  "@id": "https://beatenberg-resortspa.ch/spa#spa",
  "name": "Beatenberg Wellness & Spa",
  "description": getTranslatedDescription('spaDetailedDescription', language),
  "url": "https://beatenberg-resortspa.ch/spa",
  "image": [
    "https://beatenberg-resortspa.ch/images/spa/spa-exterior.webp",
    "https://beatenberg-resortspa.ch/images/spa/spa-pool.webp",
    "https://beatenberg-resortspa.ch/images/spa/treatment-room.webp"
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Beatenberg",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "telephone": "+41 33 841 00 21",
  "paymentAccepted": ["Cash", "Credit Card", "Debit Card"],
  "currenciesAccepted": "CHF",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "07:00",
      "closes": "22:00"
    }
  ],
  "email": "info@beatenberg-resortspa.ch",
  "priceRange": "CHF 80-350",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Spa Services & Treatments",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Alpine Stone Therapy",
          "description": "Hot stone massage using heated Alpine minerals and essential oils"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "NutraSwiss Wellness Programs",
          "description": "Comprehensive 3-7 day wellness programs by NutraSwiss experts"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mountain Herb Facial",
          "description": "Rejuvenating facial treatment using Swiss Alpine botanicals"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Swiss Chocolate Body Wrap",
          "description": "Indulgent body treatment with premium Swiss chocolate"
        }
      }
    ]
  },
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Finnish Sauna",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Steam Room",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Indoor Pool",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Relaxation Lounge",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Mountain View Treatment Rooms",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Couples Treatment Rooms",
      "value": true
    }
  ]
});

// Generate translated restaurant structured data
export const getRestaurantStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "@id": "https://beatenberg-resortspa.ch/dining#restaurant",
  "name": "Restaurant Jungfrau - Beatenberg Resort & Spa",
  "description": getTranslatedDescription('restaurantDescription', language),
  "image": [
    "https://beatenberg-resortspa.ch/images/main_restaurant.png",
    "https://beatenberg-resortspa.ch/images/alpine_terrace.jpg",
    "https://beatenberg-resortspa.ch/images/breakfast_buffet.jpg"
  ],
  "url": "https://beatenberg-resortspa.ch/dining",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Beatenberg",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "telephone": "+41 33 841 00 21",
  "email": "info@beatenberg-resortspa.ch",
  "servesCuisine": ["Swiss", "International", "European", "Alpine Cuisine"],
  "priceRange": "CHF 30-80",
  "paymentAccepted": ["Cash", "Credit Card", "Debit Card"],
  "currenciesAccepted": "CHF",
  "acceptsReservations": true,
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "07:00",
      "closes": "22:00"
    }
  ],
  "hasMenu": {
    "@type": "Menu",
    "name": "Five-Course Tasting Menu",
    "description": "Chef's seasonal selection showcasing Swiss Alpine ingredients and traditional recipes with a modern twist",
    "url": "https://beatenberg-resortspa.ch/dining"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.4",
    "reviewCount": "10",
    "bestRating": "5",
    "worstRating": "1"
  },
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Outdoor Seating",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Mountain Views",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Private Dining Rooms",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Vegetarian Options",
      "value": true
    }
  ],
  "sameAs": [
    "https://www.google.com/maps/place/Restaurant+Jungfrau/@46.6976705,7.7945598,17z/data=!4m6!3m5!1s0x478fa5bd5f041421:0xd0898cc8ef8c20a7!8m2!3d46.6976705!4d7.7945598!16s%2Fg%2F11l2vxmgnc"
  ]
});

// Generate translated accommodations structured data
export const getAccommodationsStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": getTranslatedDescription('accommodationsPageName', language),
  "description": getTranslatedDescription('accommodationsDescription', language),
  "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations`,
  "inLanguage": language === 'zh-CN' ? 'zh-CN' : (language === 'ko' ? 'ko' : language),
  "mainEntity": {
    "@type": "ItemList",
    "name": getTranslatedDescription('accommodationsListName', language),
    "description": getTranslatedDescription('accommodationsListDescription', language),
    "numberOfItems": 9,
    "itemListElement": [
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#family-suite`,
        "name": getTranslatedDescription('familySuiteName', language),
        "description": getTranslatedDescription('familySuiteDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#family-suite`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 6
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 65,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Private Balcony",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Kitchenette",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Ensuite Espresso Machine",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#junior-suite`,
        "name": getTranslatedDescription('juniorSuiteName', language),
        "description": getTranslatedDescription('juniorSuiteDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#junior-suite`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 4
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 50,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Private Balcony",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Kitchenette",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Ensuite Espresso Machine",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#triple-rooms`,
        "name": getTranslatedDescription('tripleRoomName', language),
        "description": getTranslatedDescription('tripleRoomDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#triple-rooms`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 4
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 30,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Family Amenities",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Mountain or Lake View",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#double-rooms`,
        "name": getTranslatedDescription('doubleRoomName', language),
        "description": getTranslatedDescription('doubleRoomDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#double-rooms`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 3
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 35,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Couple Amenities",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Mountain or Lake View",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#single-rooms`,
        "name": getTranslatedDescription('singleRoomName', language),
        "description": getTranslatedDescription('singleRoomDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#single-rooms`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 1
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 20,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Solo Traveler Amenities",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Mountain or Lake View",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#alpine-double-twin`,
        "name": getTranslatedDescription('alpineDoubleTwinName', language),
        "description": getTranslatedDescription('alpineDoubleTwinDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#alpine-double-twin`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 2
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 32,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Private Balcony",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Lake View",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Flexible Bedding",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#alpine-classic-double-twin`,
        "name": getTranslatedDescription('alpineClassicDoubleTwinName', language),
        "description": getTranslatedDescription('alpineClassicDoubleTwinDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#alpine-classic-double-twin`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 2
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 28,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Village View",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Flexible Bedding",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Classic Alpine Charm",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#jungfrau-single`,
        "name": getTranslatedDescription('jungfrauSingleName', language),
        "description": getTranslatedDescription('jungfrauSingleDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#jungfrau-single`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 1
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 20,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Private Balcony",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Lake View",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Premium Single",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "@id": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#heritage-single`,
        "name": getTranslatedDescription('heritageSingleName', language),
        "description": getTranslatedDescription('heritageSingleDescription', language),
        "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/accommodations#heritage-single`,
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 1
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 20,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Village View",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Heritage Character",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Classic Swiss Hospitality",
            "value": true
          }
        ]
      }
    ]
  }
});

// Generate translated accommodations FAQ schema
export const getAccommodationsFAQSchema = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "inLanguage": language === 'zh-CN' ? 'zh-CN' : (language === 'ko' ? 'ko' : language),
  "mainEntity": [
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqCheckInOut', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqCheckInOutAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqBreakfast', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqBreakfastAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqViews', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqViewsAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqAmenities', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqAmenitiesAnswer', language)
      }
    }
  ]
});

// Generate translated spa FAQ schema
export const getSpaFAQSchema = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "inLanguage": language === 'zh-CN' ? 'zh-CN' : (language === 'ko' ? 'ko' : language),
  "mainEntity": [
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaBooking', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaBookingAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaMassages', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaMassagesAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaSaunaPackage', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaSaunaPackageAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaHours', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaHoursAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaPricing', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaPricingAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaAccess', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaAccessAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaCancellation', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaCancellationAnswer', language)
      }
    },
    {
      "@type": "Question",
      "name": getTranslatedDescription('faqSpaPreparation', language),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": getTranslatedDescription('faqSpaPreparationAnswer', language)
      }
    }
  ]
});

// Generate translated events venue structured data
export const getEventsVenueStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "EventVenue",
  "@id": "https://beatenberg-resortspa.ch/events#venue",
  "name": "Beatenberg Resort & Spa - Event & Wedding Venue",
  "description": getTranslatedDescription('eventsDescription', language),
  "url": `https://beatenberg-resortspa.ch${language !== 'en' ? `/${language}` : ''}/events`,
  "image": [
    "https://beatenberg-resortspa.ch/images/events/wedding.webp",
    "https://beatenberg-resortspa.ch/images/events/corporate.webp",
    "https://beatenberg-resortspa.ch/images/events/celebrations.webp"
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Beatenberg",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "telephone": "+41 33 841 00 21",
  "maximumAttendeeCapacity": 200,
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Wedding Planning Services",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Catering Services",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Audio/Visual Equipment",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Mountain View Terrace",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Indoor Event Spaces",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Accommodations On-Site",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Free WiFi",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Parking",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Billiards Room",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Private Balconies",
      "value": true
    }
  ]
});

// Generate translated event planning service structured data
export const getEventPlanningServiceStructuredData = (language: SEOLanguage = 'en') => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Wedding Planning & Event Coordination",
  "name": "Event Planning Services",
  "description": getTranslatedDescription('eventPlanningDescription', language),
  "provider": {
    "@type": "Organization",
    "name": "Beatenberg Resort & Spa",
    "url": "https://beatenberg-resortspa.ch"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Switzerland"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Event Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Wedding Ceremonies & Receptions",
          "description": "Complete wedding planning and coordination services with breathtaking Alpine backdrop"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Corporate Events",
          "description": "Business meetings, conferences, team building, and corporate retreats"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Private Celebrations",
          "description": "Birthdays, anniversaries, family reunions, and special occasions"
        }
      }
    ]
  }
});

// Generate translated events FAQ schema
export const getEventsFAQSchema = (language: SEOLanguage = 'en') => {
  const faqTranslations = {
    en: [
      {
        question: "What is the maximum capacity for weddings and events?",
        answer: "Our event venues can accommodate up to 200 guests for weddings and special events. We offer both indoor and outdoor spaces with stunning Alpine views, and our team can help configure the space to suit your specific needs."
      },
      {
        question: "Do you provide wedding planning services?",
        answer: "Yes, we offer comprehensive wedding planning services including venue setup, catering coordination, accommodation arrangements for guests, audiovisual equipment, and on-site coordination. Our experienced event team will work with you to create your perfect Alpine wedding."
      },
      {
        question: "Can you accommodate corporate events and meetings?",
        answer: "Absolutely. We specialize in corporate events, business meetings, conferences, and team-building retreats. Our facilities include modern audiovisual equipment, high-speed WiFi, flexible meeting spaces, and professional catering services."
      },
      {
        question: "What catering options are available for events?",
        answer: "We offer customizable catering menus featuring Swiss and international cuisine, prepared by our experienced culinary team. Options include seated dinners, buffet service, cocktail receptions, and traditional Swiss specialties. We can accommodate dietary restrictions and preferences."
      }
    ],
    de: [
      {
        question: "Was ist die maximale Kapazität für Hochzeiten und Events?",
        answer: "Unsere Veranstaltungsräume können bis zu 200 Gäste für Hochzeiten und besondere Veranstaltungen aufnehmen. Wir bieten sowohl Innen- als auch Außenbereiche mit atemberaubendem Alpenblick, und unser Team kann Ihnen helfen, den Raum an Ihre spezifischen Bedürfnisse anzupassen."
      },
      {
        question: "Bieten Sie Hochzeitsplanungsservices an?",
        answer: "Ja, wir bieten umfassende Hochzeitsplanungsservices einschließlich Veranstaltungsaufbau, Catering-Koordination, Unterkunftsarrangements für Gäste, audiovisuelle Ausrüstung und Vor-Ort-Koordination. Unser erfahrenes Event-Team arbeitet mit Ihnen zusammen, um Ihre perfekte Alpen-Hochzeit zu schaffen."
      },
      {
        question: "Können Sie Firmenevents und Meetings ausrichten?",
        answer: "Auf jeden Fall. Wir sind spezialisiert auf Firmenevents, Geschäftstreffen, Konferenzen und Teambuilding-Retreats. Unsere Einrichtungen umfassen moderne audiovisuelle Ausrüstung, High-Speed-WLAN, flexible Tagungsräume und professionelle Catering-Services."
      },
      {
        question: "Welche Catering-Optionen sind für Events verfügbar?",
        answer: "Wir bieten anpassbare Catering-Menüs mit Schweizer und internationaler Küche, zubereitet von unserem erfahrenen kulinarischen Team. Optionen umfassen Tafeldinner, Buffet-Service, Cocktail-Empfänge und traditionelle Schweizer Spezialitäten. Wir können Ernährungseinschränkungen und -vorlieben berücksichtigen."
      }
    ],
    fr: [
      {
        question: "Quelle est la capacité maximale pour les mariages et événements?",
        answer: "Nos espaces événementiels peuvent accueillir jusqu'à 200 invités pour les mariages et événements spéciaux. Nous proposons des espaces intérieurs et extérieurs avec une vue imprenable sur les Alpes, et notre équipe peut vous aider à configurer l'espace selon vos besoins spécifiques."
      },
      {
        question: "Proposez-vous des services de planification de mariage?",
        answer: "Oui, nous proposons des services complets de planification de mariage incluant l'aménagement du lieu, la coordination du traiteur, les arrangements d'hébergement pour les invités, l'équipement audiovisuel et la coordination sur place. Notre équipe événementielle expérimentée travaillera avec vous pour créer votre mariage alpin parfait."
      },
      {
        question: "Pouvez-vous accueillir des événements d'entreprise et des réunions?",
        answer: "Absolument. Nous sommes spécialisés dans les événements d'entreprise, les réunions d'affaires, les conférences et les retraites de team building. Nos installations comprennent un équipement audiovisuel moderne, le WiFi haut débit, des espaces de réunion flexibles et des services de restauration professionnels."
      },
      {
        question: "Quelles options de restauration sont disponibles pour les événements?",
        answer: "Nous proposons des menus de restauration personnalisables mettant en vedette la cuisine suisse et internationale, préparée par notre équipe culinaire expérimentée. Les options incluent des dîners assis, un service buffet, des réceptions cocktail et des spécialités suisses traditionnelles. Nous pouvons accommoder les restrictions et préférences alimentaires."
      }
    ]
  };

  const faqs = faqTranslations[language] || faqTranslations.en;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "inLanguage": language === 'zh-CN' ? 'zh-CN' : (language === 'ko' ? 'ko' : language),
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};

// Export all helper functions
export const getTranslatedStructuredData = {
  business: getBusinessStructuredData,
  website: getWebsiteStructuredData,
  organization: getOrganizationStructuredData,
  spa: getSpaStructuredData,
  enhancedSpa: getEnhancedSpaStructuredData,
  restaurant: getRestaurantStructuredData,
  accommodations: getAccommodationsStructuredData,
  accommodationsFAQ: getAccommodationsFAQSchema,
  spaFAQ: getSpaFAQSchema,
  eventsVenue: getEventsVenueStructuredData,
  eventPlanningService: getEventPlanningServiceStructuredData,
  eventsFAQ: getEventsFAQSchema,
  attractions: (language: SEOLanguage = 'en') => {
    const langCode = language === 'zh-CN' ? 'zh-CN' : (language === 'ko' ? 'ko' : language);
    const translations: Record<string, any> = {
      en: {
        name: "Beatenberg & Bernese Oberland Attractions",
        description: "Discover world-famous Swiss Alpine attractions, activities, and experiences from Beatenberg Resort & Spa. Easy access to Jungfraujoch, Interlaken, and premier hiking trails.",
        attractions: [
          {
            name: "Jungfraujoch - Top of Europe",
            description: "UNESCO World Heritage site at 3,454m altitude with observation deck, Ice Palace, and Sphinx Observatory"
          },
          {
            name: "Interlaken",
            description: "Gateway to the Swiss Alps with adventure sports, shopping, and lakeside promenades between Lake Thun and Lake Brienz"
          },
          {
            name: "Lake Thun",
            description: "Crystal-clear Alpine lake with boat cruises, water sports, and scenic lakeside villages"
          },
          {
            name: "Niederhorn Mountain",
            description: "Accessible mountain peak with panoramic 360-degree views of the Alps and Lake Thun"
          }
        ],
        activities: [
          {
            name: "Summer Alpine Hiking",
            description: "300km of marked Alpine hiking trails with varying difficulty levels"
          },
          {
            name: "Winter Skiing & Snowboarding",
            description: "Access to 200km of ski slopes in Grindelwald and Interlaken ski regions"
          },
          {
            name: "Spring Mountain Biking",
            description: "Scenic mountain bike trails through Alpine meadows and forests"
          },
          {
            name: "Autumn Photography Tours",
            description: "Capture stunning fall foliage against Alpine peaks"
          }
        ]
      },
      de: {
        name: "Beatenberg & Berner Oberland Attraktionen",
        description: "Entdecken Sie weltberühmte Schweizer Alpen-Attraktionen, Aktivitäten und Erlebnisse vom Beatenberg Resort & Spa aus. Einfacher Zugang zum Jungfraujoch, Interlaken und erstklassigen Wanderwegen.",
        attractions: [
          {
            name: "Jungfraujoch - Top of Europe",
            description: "UNESCO-Weltkulturerbe auf 3.454 m Höhe mit Aussichtsplattform, Eispalast und Sphinx-Observatorium"
          },
          {
            name: "Interlaken",
            description: "Tor zu den Schweizer Alpen mit Abenteuersport, Shopping und Seepromenaden zwischen Thunersee und Brienzersee"
          },
          {
            name: "Thunersee",
            description: "Kristallklarer Alpensee mit Bootsfahrten, Wassersport und malerischen Seeuferdörfern"
          },
          {
            name: "Niederhorn",
            description: "Zugänglicher Berggipfel mit Panoramablick 360 Grad auf die Alpen und den Thunersee"
          }
        ],
        activities: [
          {
            name: "Sommer-Alpenwandern",
            description: "300 km markierte Alpenwanderwege mit unterschiedlichen Schwierigkeitsgraden"
          },
          {
            name: "Winter-Skifahren & Snowboarden",
            description: "Zugang zu 200 km Skipisten in Grindelwald und Interlaken Ski-Regionen"
          },
          {
            name: "Frühling-Mountainbiking",
            description: "Malerische Mountainbike-Trails durch Alpenwiesen und Wälder"
          },
          {
            name: "Herbst-Fotografie-Touren",
            description: "Erfassen Sie atemberaubendes Herbstlaub vor Alpengipfeln"
          }
        ]
      },
      fr: {
        name: "Attractions Beatenberg & Oberland Bernois",
        description: "Découvrez les attractions, activités et expériences alpines suisses mondialement connues depuis le Beatenberg Resort & Spa. Accès facile au Jungfraujoch, Interlaken et aux sentiers de randonnée de premier plan.",
        attractions: [
          {
            name: "Jungfraujoch - Top of Europe",
            description: "Site du patrimoine mondial de l'UNESCO à 3 454 m d'altitude avec terrasse d'observation, Palais des Glaces et Observatoire Sphinx"
          },
          {
            name: "Interlaken",
            description: "Porte d'entrée des Alpes suisses avec sports d'aventure, shopping et promenades au bord du lac entre le lac de Thoune et le lac de Brienz"
          },
          {
            name: "Lac de Thoune",
            description: "Lac alpin cristallin avec croisières en bateau, sports nautiques et villages pittoresques au bord du lac"
          },
          {
            name: "Mont Niederhorn",
            description: "Sommet de montagne accessible avec vues panoramiques à 360 degrés sur les Alpes et le lac de Thoune"
          }
        ],
        activities: [
          {
            name: "Randonnée Alpine d'Été",
            description: "300 km de sentiers de randonnée alpins balisés avec différents niveaux de difficulté"
          },
          {
            name: "Ski & Snowboard d'Hiver",
            description: "Accès à 200 km de pistes de ski dans les régions de ski de Grindelwald et Interlaken"
          },
          {
            name: "VTT de Printemps",
            description: "Sentiers de vélo de montagne pittoresques à travers les prairies et forêts alpines"
          },
          {
            name: "Tours Photographiques d'Automne",
            description: "Capturez les magnifiques couleurs d'automne contre les sommets alpins"
          }
        ]
      }
    };

    const t = translations[language] || translations.en;
    const baseUrl = language === 'en' ? 'https://beatenberg-resortspa.ch/local-attractions' : `https://beatenberg-resortspa.ch/${langCode}/local-attractions`;

    return {
      "@context": "https://schema.org",
      "@type": "TouristDestination",
      "@id": `${baseUrl}#destination`,
      "name": t.name,
      "description": t.description,
      "url": baseUrl,
      
      "includesAttraction": t.attractions.map((attraction: any, index: number) => ({
        "@type": "TouristAttraction",
        "@id": index === 0
          ? `${baseUrl}#jungfraujoch`
          : index === 1
          ? `${baseUrl}#interlaken`
          : index === 2
          ? `${baseUrl}#lake-thun`
          : `${baseUrl}#niederhorn`,
        "name": attraction.name,
        "description": attraction.description,
        "image": `https://beatenberg-resortspa.ch/images/attractions/${index === 0 ? 'jungfraujoch' : index === 1 ? 'interlaken' : index === 2 ? 'lake-thun' : 'niederhorn'}.webp`,
        "geo": index === 0 ? {
          "@type": "GeoCoordinates",
          "latitude": 46.5475,
          "longitude": 7.9850
        } : index === 1 ? {
          "@type": "GeoCoordinates",
          "latitude": 46.6863,
          "longitude": 7.8632
        } : index === 2 ? {
          "@type": "GeoCoordinates",
          "latitude": 46.7433,
          "longitude": 7.6287
        } : {
          "@type": "GeoCoordinates",
          "latitude": 46.7333,
          "longitude": 7.7867
        },
        "touristType": index === 0 ? ["Nature Lovers", "Adventure Seekers", "Photographers", "Families"] :
                       index === 1 ? ["Adventure Seekers", "Shoppers", "Families"] :
                       index === 2 ? ["Nature Lovers", "Families", "Water Sports Enthusiasts"] :
                       ["Hikers", "Nature Lovers", "Photographers"]
      }))
    };
  },
  seasonalActivities: (language: SEOLanguage = 'en') => {
    const langCode = language === 'zh-CN' ? 'zh-CN' : (language === 'ko' ? 'ko' : language);
    const translations: Record<string, any> = {
      en: {
        name: "Seasonal Activities in Beatenberg",
        description: "Year-round activities and experiences near Beatenberg Resort & Spa",
        activities: [
          {
            name: "Summer Alpine Hiking",
            description: "300km of marked Alpine hiking trails with varying difficulty levels"
          },
          {
            name: "Winter Skiing & Snowboarding",
            description: "Access to 200km of ski slopes in Grindelwald and Interlaken ski regions"
          },
          {
            name: "Spring Mountain Biking",
            description: "Scenic mountain bike trails through Alpine meadows and forests"
          },
          {
            name: "Autumn Photography Tours",
            description: "Capture stunning fall foliage against Alpine peaks"
          }
        ]
      },
      de: {
        name: "Saisonale Aktivitäten in Beatenberg",
        description: "Ganzjährige Aktivitäten und Erlebnisse in der Nähe des Beatenberg Resort & Spa",
        activities: [
          {
            name: "Sommer-Alpenwandern",
            description: "300 km markierte Alpenwanderwege mit unterschiedlichen Schwierigkeitsgraden"
          },
          {
            name: "Winter-Skifahren & Snowboarden",
            description: "Zugang zu 200 km Skipisten in Grindelwald und Interlaken Ski-Regionen"
          },
          {
            name: "Frühling-Mountainbiking",
            description: "Malerische Mountainbike-Trails durch Alpenwiesen und Wälder"
          },
          {
            name: "Herbst-Fotografie-Touren",
            description: "Erfassen Sie atemberaubendes Herbstlaub vor Alpengipfeln"
          }
        ]
      },
      fr: {
        name: "Activités Saisonnières à Beatenberg",
        description: "Activités et expériences toute l'année près du Beatenberg Resort & Spa",
        activities: [
          {
            name: "Randonnée Alpine d'Été",
            description: "300 km de sentiers de randonnée alpins balisés avec différents niveaux de difficulté"
          },
          {
            name: "Ski & Snowboard d'Hiver",
            description: "Accès à 200 km de pistes de ski dans les régions de ski de Grindelwald et Interlaken"
          },
          {
            name: "VTT de Printemps",
            description: "Sentiers de vélo de montagne pittoresques à travers les prairies et forêts alpines"
          },
          {
            name: "Tours Photographiques d'Automne",
            description: "Capturez les magnifiques couleurs d'automne contre les sommets alpins"
          }
        ]
      }
    };

    const t = translations[language] || translations.en;
    const baseUrl = language === 'en' ? 'https://beatenberg-resortspa.ch/local-attractions' : `https://beatenberg-resortspa.ch/${langCode}/local-attractions`;

    return {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "@id": `${baseUrl}#activities`,
      "name": t.name,
      "description": t.description,
      "url": baseUrl,
      
      "itemListElement": t.activities.map((activity: any, index: number) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Thing",
          "name": activity.name,
          "description": activity.description
        }
      }))
    };
  }
};

